import React, { Component, ErrorInfo, ReactNode } from 'react';
import { ErrorPage } from '../ErrorPage';

interface Props {
  readonly children: ReactNode;
  readonly advisers?: boolean;
}

interface State {
  readonly hasError: boolean;
}

// eslint-disable-next-line functional/no-class
class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    // eslint-disable-next-line functional/no-this-expression
    if (this.state.hasError) {
      <ErrorPage />;
    }

    // eslint-disable-next-line @typescript-eslint/no-this-alias, functional/no-this-expression
    const newLocal = this;
    return newLocal.props.children;
  }
}

export default ErrorBoundary;
